import React, { useState } from "react";
import { useLazyQuery } from "@apollo/react-hooks";

import RESEND_EMAIL_TEMPLATE from "./queries";

import FinishApplicationIcon from "../../../assets/application-in-progress.png";

const VerifyEmail = () => {
  const [hasTemplateBeenResent, setHasTemplateBeenResent] = useState(false);
  const [resendEmail] = useLazyQuery(RESEND_EMAIL_TEMPLATE, {
    onCompleted() {
      setHasTemplateBeenResent(true);
    }
  });
  return (
    <div className="flex items-center justify-center">
      <div className="flex flex-col items-center p-12">
        <img
          alt="Email-Icon"
          className="stuff"
          src={FinishApplicationIcon}
          style={{ width: 450, objectFit: "contain" }}
        />
        <p className="text-xl font-bold text-center pt-16">
          Please verify your email before getting started
        </p>
        <button
          className="btn btn-green mt-5"
          type="button"
          onClick={resendEmail}
        >
          {hasTemplateBeenResent ? "Email has been resent!" : "Resend Email"}
        </button>
      </div>
    </div>
  );
};

export default VerifyEmail;
